<template>
  <div class="home" v-if="$store.state.menuList.length!==0&&$store.state.userInfo.user">
    <img class="home-bg"
         src="@/assets/homebg.jpg">
    <div class="home-main">
      <div class="home-head">
        <div class="home-logo">
          <img class="home-title-logo"
               src="@/assets/logo.png">
          <div class="home-title-text">
            <div class="home-title-text_ch">凤凰市场网络管理中心</div>
            <div class="home-title-text_en">Phoenix    Marketing   Management</div>
          </div>
        </div>
        <div class="home-photo">
          <img :src="$store.state.userInfo.user.networkHeadUrl">
          <div class="home-name">{{$store.state.userInfo.user.name}}</div>
        </div>
      </div>
      <div class="home-router_list">
        <div class="home-router_list_row"
             v-for="row in Math.ceil(routerList.length/6)"
             :key="row">
          <div v-for="index in 6"
               :key="index"
               class="home-router_list_item">
            <router-card :value="routerList[(row-1)*6 + (index-1)]"></router-card>
          </div>
        </div>
      </div>
      <div class="home-button"
           @click="logout">退出</div>
    </div>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import routerCard from '@/components/routerCard'
import _ from 'lodash'
export default {
  components: {
    routerCard
  },
  data() {
    return {
      routerList: []
    }
  },
  async created(){
      await this.$store.dispatch('getMenu')
  await this.$store.dispatch('getUser')
  this.routerList = _.concat(
      this.$store.state.mainList,
      this.$store.state.settingList
    )
  },
  methods: {
    logout() {
      axios
        .get(api.logout)
        .then(res => {
          if (res.data.code === 0) {
            console.log('注销成功')
            this.$router.replace({ path: '/login' })
          } else {
            console.log('注销失败', res.data.msg)
            this.$message.error('网络错误，请稍后重试')
          }
        })
        .catch(error => {
          console.log('注销失败', error)
          this.$message.error('网络错误，请稍后重试')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .home-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
  }
  .home-main {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    .home-head {
      width: 85%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
      .home-logo {
        display: flex;
        align-items: center;
        z-index: 1000;
        .home-title-logo {
          width: 46px;
          height: 46px;
          margin-right: 11px;
        }
        .home-title-text {
          color: #eee;
          .home-title-text_ch {
            font-size: 33px;
          }
          .home-title-text_en {
            font-size: 22px;
          }
        }
      }
      .home-photo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          height: 37px;
          width: 37px;
          border-radius: 50%;
          background: #fff;
        }
        .home-name {
          color: #fff;
          font-size: 14px;
        }
      }
    }
    .home-router_list {
      width: 85%;
      display: flex;
      flex-direction: column;
      .home-router_list_row {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-between;
        .home-router_list_item {
          display: flex;
          margin-top: 80px;
          width: 100px;
        }
      }
    }
    .home-button {
      width: 305px;
      height: 45px;
      border-radius: 4px;
      border: 1px solid #fff;
      color: #fff;
      font-size: 16px;
      text-align: center;
      line-height: 45px;
      margin-top: 105px;
      cursor: pointer;
      &:hover {
        background: #f0722b;
        border-color: #f0722b;
      }
    }
  }
}
</style>
